import {
    communityListRequest,
    communityItemRequest
} from "../../../actions/community-actions"
import CommunityListItem from "../../common/CommunityListItem"
import buildListContainer from "../../common/build-list-container"

export default buildListContainer(
    CommunityListItem,
    null,
    communityListRequest,
    communityItemRequest,
    "communities"
)
